<template>
  <div class="activity">
    <div class="activity-top">
      <DActivityAvatar :activity="activity" />

      <div class="activity-title">
        <DActivityAuthor :activity="activity" />

        <span>
          launched
          <a
            class="resource-link"
            :href="activity.source.url"
            :title="activity.source.title"
            @click.stop
          >
            {{ activity.source.title }}
          </a>
        </span>

        <DActivityTimestamp
          :activity="activity"
          class="visible-until-sm"
        />
      </div>

      <DActivityTimestamp
        :activity="activity"
        class="hidden-until-md"
      />

      <DActivityActions
        v-if="isUserSignedIn && !isRepost"
        :activity="activity"
        @activity-removed="activityRemoved"
      />
    </div>

    <DActivityBook
      :book="activity.source"
      class="space-top-2em"
      :has-video-review="(activity.source.review && !!activity.source.review.video_url)"
      :is-user-signed-in="isUserSignedIn"
      :verdict="(activity.source.review && activity.source.review.verdict)"
    />
  </div>
</template>

<script>
import activityMixin from '../shared/activity-mixin';

export default {
  mixins: [
    activityMixin,
  ],
};
</script>
